module.exports = __webpack_public_path__ + "e81f48c8fa6400f6126c3f4be658d6ae.jpg";


//////////////////
// WEBPACK FOOTER
// ./public/content/assets/2056_teaser_image.jpg
// module id = 580
// module chunks = 0